module.exports = __webpack_public_path__ + "static/img/wear_detect1.1300a9a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus3/wear_detect1.gif
// module id = okzG
// module chunks = 1